// Hills Bank Draw Request Categories
export const HILLS_BANK_CATEGORIES = [
  { code: "101", name: "Excavation/Backfill", fullName: "101 Excavation/Backfill" },
  { code: "102", name: "Footings", fullName: "102 Footings" },
  { code: "103", name: "Foundation/Walls/Slab", fullName: "103 Foundation/Walls/Slab" },
  { code: "104", name: "Sewer & Water/Septic & Well", fullName: "104 Sewer & Water/Septic & Well" },
  { code: "201", name: "Framing/Floor Deck/Partitions", fullName: "201 Framing/Floor Deck/Partitions" },
  { code: "202", name: "Roofing", fullName: "202 Roofing" },
  { code: "203", name: "Windows/Exterior Doors", fullName: "203 Windows/Exterior Doors" },
  { code: "301", name: "Electrical", fullName: "301 Electrical" },
  { code: "302", name: "HVAC", fullName: "302 HVAC" },
  { code: "303", name: "Plumbing", fullName: "303 Plumbing" },
  { code: "401", name: "Flatwork (driveway/sidewalks)", fullName: "401 Flatwork (driveway/sidewalks)" },
  { code: "402", name: "Garage Doors", fullName: "402 Garage Doors" },
  { code: "403", name: "Gutters/Spouting", fullName: "403 Gutters/Spouting" },
  { code: "404", name: "Insulation", fullName: "404 Insulation" },
  { code: "405", name: "Landscaping", fullName: "405 Landscaping" },
  { code: "406", name: "Siding/Masonry (brick/stone)", fullName: "406 Siding/Masonry (brick/stone)" },
  { code: "501", name: "Cabinets/Vanities/Countertops", fullName: "501 Cabinets/Vanities/Countertops" },
  { code: "502", name: "Drywall", fullName: "502 Drywall" },
  { code: "503", name: "Flooring", fullName: "503 Flooring" },
  { code: "601", name: "Fixtures - HVAC & Plumbing", fullName: "601 Fixtures - HVAC & Plumbing" },
  { code: "602", name: "Fixtures - Lighting", fullName: "602 Fixtures - Lighting" },
  { code: "603", name: "Paint/Wall Finish", fullName: "603 Paint/Wall Finish" },
  { code: "604", name: "Shelving/Accessories", fullName: "604 Shelving/Accessories" },
  { code: "605", name: "Trim/Interior Doors", fullName: "605 Trim/Interior Doors" },
  { code: "701", name: "Appliances", fullName: "701 Appliances" },
  { code: "702", name: "Fireplace", fullName: "702 Fireplace" },
  { code: "703", name: "Window Coverings", fullName: "703 Window Coverings" },
  { code: "801", name: "Landfill/Portable Toilets/Cleaning", fullName: "801 Landfill/Portable Toilets/Cleaning" },
  { code: "802", name: "Permits/Insurance/Bonds", fullName: "802 Permits/Insurance/Bonds" },
  { code: "803", name: "Professional Fees: Legal/Architect/Survey", fullName: "803 Professional Fees: Legal/Architect/Survey" },
  { code: "804", name: "Rentals", fullName: "804 Rentals" },
  { code: "805", name: "Utilities", fullName: "805 Utilities" },
  { code: "806", name: "Allowances", fullName: "806 Allowances" },
];

// Helper function to get category by code
export const getCategoryByCode = (code) => {
  return HILLS_BANK_CATEGORIES.find(cat => cat.code === code);
};

// Helper function to search categories by name
export const searchCategories = (searchTerm) => {
  if (!searchTerm) return HILLS_BANK_CATEGORIES;
  const term = searchTerm.toLowerCase();
  return HILLS_BANK_CATEGORIES.filter(cat => 
    cat.name.toLowerCase().includes(term) || 
    cat.code.includes(term)
  );
};
